<template>
  <footer>
    <br><br><br><br><br><br><br>
  </footer>
</template>

<script>
export default {
  name: "Foot"
};
</script>

<style>
footer {
	background: #F2F6FA;
}
</style>
